import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Box,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchApi } from './fetchApi';


interface LieferscheinListeEintrag {
  id: number;
  lieferschein_nr: string;
  quelle_name: string;   // Sender
  empfaenger: string;
  status: string;        // 'offen' | 'versendet' | 'abgeschlossen'
  bemerkung?: string;
  erstellt_am: string;
  bewegungs_typ: string; // 'EXTERN_AUSGANG' | 'WARENEINGANG' | 'INTERN_UMLAGERUNG' | 'SONSTIG'
}

export default function LieferscheinListe() {
  const [liste, setListe] = useState<LieferscheinListeEintrag[]>([]);
  const [laden, setLaden] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    async function ladeDaten() {
      try {
       const res = await fetchApi('/api/lieferschein/view/list');
        if (!res.ok)
          throw new Error('Fehler beim Laden der Lieferschein-Liste');

        const data = await res.json();
        setListe(Array.isArray(data) ? data : []);
      } catch (err: any) {
  console.error('❌ Fehler beim Laden der Liste:', err);
  if (err?.message === '401') {
    console.error('Session abgelaufen. Bitte neu einloggen.');
  }
} finally {
  setLaden(false);
}

    }

    ladeDaten();
  }, []);

  if (laden) {
    return (
      <Container>
        <Box mt={4} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  // Kleine Hilfsfunktion für schönere Anzeige des Typs
  const formatBewegungsTyp = (typ: string) => {
    switch (typ) {
      case 'EXTERN_AUSGANG':
        return 'Warenausgang';
      case 'WARENEINGANG':
        return 'Wareneingang';
      case 'INTERN_UMLAGERUNG':
        return 'Interne Umlagerung';
      case 'SONSTIG':
      default:
        return 'Sonstige';
    }
  };

  return (
    <Container>
      <Box mt={4} mb={2}>
        <Typography variant="h5">Lieferscheine Übersicht</Typography>
      </Box>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Lieferschein-Nr.</TableCell>
            <TableCell>Sender</TableCell>
            <TableCell>Typ</TableCell>
            <TableCell>Empfänger</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Erstellt am</TableCell>
            <TableCell>Details</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {liste.map((ls) => (
            <TableRow key={ls.id}>
              <TableCell>{ls.lieferschein_nr}</TableCell>
              <TableCell>{ls.quelle_name}</TableCell>
              <TableCell>{formatBewegungsTyp(ls.bewegungs_typ)}</TableCell>
              <TableCell>{ls.empfaenger}</TableCell>

              <TableCell>
                {ls.status === 'offen' ? (
                  <span style={{ color: 'orange', fontWeight: 600 }}>
                    offen
                  </span>
                ) : ls.status === 'versendet' ? (
                  <span style={{ color: 'green', fontWeight: 600 }}>
                    versendet
                  </span>
                ) : (
                  <span style={{ color: '#1976d2', fontWeight: 600 }}>
                    abgeschlossen
                  </span>
                )}
              </TableCell>

              <TableCell>
                {new Date(ls.erstellt_am).toLocaleString('de-AT')}
              </TableCell>

              <TableCell>
                <Button
                  variant="contained"
                  onClick={() => navigate(`/lieferschein/${ls.id}`)}
                >
                  Details
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Container>
  );
}
